import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { canAccessRoute } from '@/utils/permissions'

Vue.use(VueRouter)

// 静默处理 NavigationDuplicated / NavigationRedirected 异常
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onComplete, onAbort) {
  return originalPush.call(this, location, onComplete, onAbort).catch(err => {
    if (err._isRouter || err.name === 'NavigationDuplicated') {
      return
    }
    throw err
  })
}

const originalReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace(location, onComplete, onAbort) {
  return originalReplace.call(this, location, onComplete, onAbort).catch(err => {
    if (err._isRouter || err.name === 'NavigationDuplicated') {
      return
    }
    throw err
  })
}

const routes = [
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: { noAuth: true }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: { title: '仪表板' }
  },
  {
    path: '/shipment/import',
    name: 'ShipmentImport',
    component: () => import('@/views/ShipmentImport.vue'),
    meta: { title: '采购录入', adminOnly: true }
  },
  {
    path: '/status-board',
    name: 'StatusBoard',
    component: () => import('@/views/StatusBoard.vue'),
    meta: { title: '状态看板' }
  },
  // {
  //   path: '/transit-value',
  //   name: 'TransitValue',
  //   component: () => import('@/views/TransitValue.vue'),
  //   meta: { title: '在途货值大盘', adminOnly: true }
  // },
  // {
  //   path: '/monthly-forecast',
  //   name: 'MonthlyForecast',
  //   component: () => import('@/views/MonthlyForecast.vue'),
  //   meta: { title: '月度到港预测' }
  // },
  {
    path: '/reports',
    name: 'Reports',
    component: () => import('@/views/Reports.vue'),
    meta: { title: '报表导出' }
  },
  {
    path: '/storage-management',
    name: 'StorageManagement',
    component: () => import('@/views/StorageManagement.vue'),
    meta: { title: '入库管理', adminOnly: true }
  },
  {
    path: '/user-management',
    name: 'UserManagement',
    component: () => import('@/views/UserManagement.vue'),
    meta: { title: '用户管理', adminOnly: true }
  },
  // {
  //   path: '/role-management',
  //   name: 'RoleManagement',
  //   component: () => import('@/views/RoleManagement.vue'),
  //   meta: { title: '角色管理', adminOnly: true }
  // },
  {
    path: '/profile',
    name: 'Profile',
    component: () => import('@/views/Profile.vue'),
    meta: { title: '个人中心' }
  },
  {
    path: '/timeline-analysis',
    name: 'TimelineAnalysis',
    component: () => import('@/views/TimelineAnalysis.vue'),
    meta: { title: '时效分析' }
  },
  {
    path: '*',
    redirect: '/login'
  }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 权限守卫
router.beforeEach(async (to, from, next) => {
  const isLoggedIn = store.getters['auth/isLoggedIn']
  const token = store.getters['auth/token']

  // 登录页：已登录就放行去 dashboard，未登录就放行
  if (to.path === '/login') {
    if (isLoggedIn || token) {
      next('/dashboard')
    } else {
      next()
    }
    return
  }

  // 其他页面：未登录（无 token）去登录页
  if (!isLoggedIn && !token) {
    next('/login')
    return
  }

  // 有 token 但还没恢复登录状态（页面刷新场景）
  if (token && !isLoggedIn) {
    try {
      await store.dispatch('auth/fetchUserInfo')
      if (!store.getters['auth/isLoggedIn']) {
        store.commit('auth/SET_LOGIN', {
          role: store.getters['auth/userRole'] || 'cargo',
          name: store.getters['auth/userName'],
          avatar: store.getters['auth/userAvatar'],
          userInfo: store.getters['auth/userInfo'],
          permissions: store.getters['auth/permissions']
        })
      }
      try {
        await store.dispatch('auth/fetchRouters')
      } catch (e) {
        console.warn('获取路由菜单失败:', e)
      }
    } catch (e) {
      store.commit('auth/SET_LOGOUT')
      next('/login')
      return
    }
  }

  const role = store.getters['auth/userRole']
  const accessibleRoutes = store.getters['auth/accessibleRoutes']

  // 权限检查
  if (!canAccessRoute(to.path, role, accessibleRoutes)) {
    next('/dashboard')
    return
  }

  next()
})

export default router
